import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const GET_APPROVALS = gql`
  ${DEDUCTION_FRAGMENT}
  query GetApprovals($params: GetApprovalsParams!) {
    getApprovals(params: $params) {
      total
      page
      limit
      items {
        ...DeductionFields
      }
      columns {
        key
        title
      }
    }
  }
`;

export default GET_APPROVALS;